module.exports = require('./helpers/bundle-url').getBundleURL('aw6oN') + "logo.c51670a8.svg";